import md5 from 'md5';

const EMAIL_ALIASES = ['email', 'e-mail', 'email address', 'email_address', 'emailaddress'];
const PHONE_ALIASES = ['phone', 'cell', 'mobile', 'cell_phone', 'cellphone', 'phone_number', 'phonenumber', 'cell phone number', 'mobile phone number', 'mobile number', 'phone number'];

export function normalizePhone(raw) {
  if (!raw) return null;
  let digits = raw.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }
  if (digits.length !== 10) return null;
  return digits;
}

export function hashValue(value) {
  return md5(value);
}

export function generateCsvString(hashes, dataType) {
  const unique = [...new Set(hashes)];
  return `${dataType}\n${unique.join('\n')}\n`;
}

export function getOutputFilename(exportMode, dataType, originalFilename, dateString) {
  if (exportMode === 'merge') {
    return `hashed_${dataType}_${dateString}.csv`;
  }
  const base = originalFilename.replace(/\.csv$/i, '');
  return `${base}_hashed_${dataType}_${dateString}.csv`;
}

export function autoDetectColumn(columns, dataType) {
  const aliases = dataType === 'email' ? EMAIL_ALIASES : PHONE_ALIASES;
  return columns.find((col) => aliases.includes(col.toLowerCase())) ?? null;
}
